import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { AmigosThyssenComponent } from './amigos-thyssen.component';
import { AmigosThyssenValidacionComponent } from './components/validacion/validacion.component';
import { AmigosThyssenSelectorMasEntradasComponent } from './components/selector-mas-entradas/selector-mas-entradas.component';
import { AmigosThyssenService } from './services/amigos-thyssen.service';
import { VentaModule } from '../venta/venta.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    AmigosThyssenComponent, 
    AmigosThyssenValidacionComponent,
    AmigosThyssenSelectorMasEntradasComponent,
  ],
  imports: [
    CommonModule,
    PerfectScrollbarModule, 
    RouterModule, 
    FormsModule, 
    ReactiveFormsModule,
    PerfectScrollbarModule,
    SharedModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    VentaModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    AmigosThyssenService,
  ],
})
export class AmigosThyssenModule {}
